import { Fragment } from 'react'
import { Row, Col } from 'antd'
import { useAppSelector } from 'hooks'
import { Question, QuestionGroup } from 'Slices/Settings/SettingsSlice'
import FatherCollapseHeader from './FatherCollapseHeader'
import { getFatherSettingChilds, getFatherSettings, getQuestionGroupChilds } from 'Helpers/SettingsHelper'

interface QuestionsRowsProps {
  collapse: string[]
  subCollapse: string[]
  setCollapse: React.Dispatch<React.SetStateAction<any[]>>
  setSubCollapse: React.Dispatch<React.SetStateAction<any[]>>
}

function QuestionsRows(props: QuestionsRowsProps) {
  const settings = useAppSelector(state => state.present.settings.settings)
  const isImagesVisible = useAppSelector(state => state.present.configuration.isImagesVisible)
  const isOmnichannelAndPricesVisibile = useAppSelector(
    state => state.present.configuration.isOmnichannelAndPricesVisibile,
  )
  const fatherSettingList = getFatherSettings(settings, isOmnichannelAndPricesVisibile, isImagesVisible)

  const renderChild = (childName: string, translation: string, id, fatherId) => {
    return (
      <div className='child' key={`${fatherId}-${id}`}>
        {translation}
      </div>
    )
  }

  return (
    <Row className='left-menu big-table-row'>
      {fatherSettingList.map(([settingsName, questionGroup]: [string, QuestionGroup], fatherId) => {
        const questions: Question[] = getQuestionGroupChilds(
          questionGroup,
          isOmnichannelAndPricesVisibile,
          isImagesVisible,
        )
        const extraChild = getFatherSettingChilds(questionGroup)

        return (
          <Fragment key={`${settingsName}-${fatherId}`}>
            <FatherCollapseHeader
              collapse={props.collapse}
              extraChild={extraChild}
              setCollapse={props.setCollapse}
              setExtraCollapse={props.setSubCollapse}
              settingsName={settingsName}
              translation={questionGroup.name}
            />
            {props.collapse.indexOf(settingsName) !== -1 ? (
              <Col
                span={24}
                className={'sub-row pl-3' + (props.collapse.indexOf(settingsName) !== -1 ? ` expanded` : '')}
                id={`question-collapse-${settingsName}`}
              >
                {questions.map((x: Question, id) => {
                  return renderChild(settingsName, x.name, id, fatherId)
                })}
                {extraChild.map((childValue: QuestionGroup) => {
                  const questions: Question[] = getQuestionGroupChilds(
                    childValue,
                    isOmnichannelAndPricesVisibile,
                    isImagesVisible,
                  )
                  return (
                    <Fragment key={childValue.name}>
                      <FatherCollapseHeader
                        collapse={props.subCollapse}
                        extraChild={null}
                        setCollapse={props.setSubCollapse}
                        setExtraCollapse={null}
                        settingsName={childValue.name}
                        translation={childValue.name}
                      />
                      {props.subCollapse.indexOf(childValue.name) !== -1 ? (
                        <Col
                          span={24}
                          className={
                            'sub-sub-row pl-3' + (props.subCollapse.indexOf(childValue.name) !== -1 ? ' expanded' : '')
                          }
                        >
                          {questions.map((x: Question, id) => {
                            return renderChild(childValue.name, x.name, id, fatherId)
                          })}
                        </Col>
                      ) : null}
                    </Fragment>
                  )
                })}
              </Col>
            ) : null}
          </Fragment>
        )
      })}
    </Row>
  )
}

export default QuestionsRows
